import { Group, List, Paper, ScrollArea, Stack, Text } from "@mantine/core"
import PortalImage from "@assets/student_portal.png"

export const PortalStep: React.FC = () => {

    return (
        <Stack gap="xl">
            <Group gap="xl">
                <Paper radius="lg" withBorder className="overflow-hidden">
                    <ScrollArea>
                        <img src={PortalImage} alt="Student Portal" style={{ maxHeight: 600 }} />
                    </ScrollArea>
                </Paper>
                <Stack justify="start" h="100%" gap="xl" maw={600}>
                    <Text size="lg">
                        The Student Portal gives you a single point of access to lots of information:
                    </Text>
                    <List withPadding spacing="sm" size="md" listStyleType="disc">
                        <List.Item>
                            Message feed with important updates
                        </List.Item>
                        <List.Item>
                            A College calendar with all your important dates
                        </List.Item>
                        <List.Item>
                            'Me' button to access your student profile
                        </List.Item>
                        <List.Item>
                            A campus map to help you find your way around
                        </List.Item>
                        <List.Item>
                            Links to various Office 365 apps
                        </List.Item>
                        <List.Item>
                            Unread emails
                        </List.Item>
                        <List.Item>
                            Teams you are a member of
                        </List.Item>
                    </List>
                    <Text size="lg">
                        You can access the Student Portal from the sidebar in Microsoft Teams, or by visiting <Text span fw={500}>https://student.godalming.ac.uk</Text> on any web browser.
                    </Text>
                </Stack>
            </Group>
        </Stack>
    )
}
